import UpdateUserProfilePayload from '../../models/payload/profile';
import { ropoloRequest } from '../axios';

const getProfile = async (token?: string) => {
  let headers = {};

  if (token) {
    headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  const res = await ropoloRequest.identityAuthMeList({ headers });

  return res.data;
};

const updateProfile = (payload: UpdateUserProfilePayload) => ropoloRequest.identityAuthMeUpdate(payload);

export { getProfile, updateProfile };
